import { render } from "./UserCenterChangeTranslateTest.vue?vue&type=template&id=29670bae&scoped=true"
import script from "./UserCenterChangeTranslateTest.vue?vue&type=script&lang=js"
export * from "./UserCenterChangeTranslateTest.vue?vue&type=script&lang=js"

import "./UserCenterChangeTranslateTest.vue?vue&type=style&index=0&id=29670bae&lang=scss&scoped=true"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29670bae"]])

export default __exports__